import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
     * Gibt alle Kalendergruppen zurück.
     */
export function getCalendarGroups(): JQueryPromise<modelsGet.ICalendarGroup[]>
{
    var endpoint = new URI("api/calendargroups");
    return api.get<modelsGet.ICalendarGroup[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt eine Kalendergruppe anhand dessen ID zurück.
 * @param id Die ID einer Kalendergruppe.
 */
export function getCalendarGroup(id: number): JQueryPromise<modelsGet.ICalendarGroup>
{
    var endpoint = new URI("api/calendargroups");
    endpoint.segment(id.toString());

    return api.get<modelsGet.ICalendarGroup>({
        endpoint: endpoint.href()
    });
}

/**
 * Gibt alle Kalender in einer bestimmten Kalendergruppe zurück.
 * @param groupId Die ID einer Gruppe.
 */
export function getCalendars(groupId: number): JQueryPromise<modelsGet.ICalendar[]>
{
    var endpoint = new URI("api/calendargroups");
    endpoint.segment(groupId.toString());
    endpoint.segment("calendars");

    return api.get<modelsGet.ICalendar[]>({
        endpoint: endpoint.href()
    });
}

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(calendarGroup: modelsPost.ICalendarGroup): JQueryPromise<any>
{
    return api.post({
        contentType: "application/json",
        endpoint: "api/calendargroups/create",
        data: JSON.stringify(calendarGroup)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, calendarGroup: modelsPost.ICalendarGroup): JQueryPromise<any>
{
    return api.put({
        contentType: "application/json",
        endpoint: `api/calendargroups/edit/${id}`,
        data: JSON.stringify(calendarGroup)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/calendargroups/delete/${id}`
    });
}